import Dexie, { PromiseExtended } from "Dexie";
import { UserPhotoTable } from "src/app/infra/database/dexie/instance/chat/schema/user-foto";
import { DexieRepository } from "src/app/infra/repository/dexie/dexie-repository.service";


export abstract class  IUserPhotoLocalRepository extends DexieRepository<UserPhotoTable, UserPhotoTable> implements IUserPhotoLocalRepository {

}
